import React from "react";
// import { useNavigate } from "react-router-dom";
import { convertToUrl, usPhoneFormat } from "../helpers";

const Header = ({practiceData}) => {
  // const navigate = useNavigate();
  
  return (
    <header className="bg-gray-50 shadow p-4">
      <div className="container mx-auto flex justify-between items-center">
        <div>
          <h1 className="text-xl md:text-2xl lg:text-3xl font-semibold md:mb-2">
            <div 
              className="text-black cursor-pointer"
              onClick={() => {
                const url = `/${convertToUrl(practiceData?.account_name)}`;
                // navigate(url);
                window.location.href = url;
              }}
            >
              {practiceData?.alt_account_name ? practiceData?.alt_account_name : practiceData?.account_name}
            </div>
          </h1>
          <p className="text-sm md:text-base font-thin text-gray-600">
            {practiceData?.phone && usPhoneFormat(practiceData?.phone)} {(practiceData?.phone && practiceData?.address) && (' | ')} {practiceData?.address}
          </p>
        </div>
      </div>
    </header>
  );
};

export default Header;
